<template>
  <div class="companies">
    <MobileTable
      v-model:selection="store.state.commonArea.selectedCommonAreas"
      :label="$route.name"
      :columns="commonArea.columns"
      :data="store.state.commonArea.commonAreas"
    />
    <DesktopTable
      v-model:selection="store.state.commonArea.selectedCommonAreas"
      :label="$route.name"
      :columns="commonArea.columns"
      :data="store.state.commonArea.commonAreas"
    />
    <Actions :items="commonArea.actions" />
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import Actions from "../../components/shared/Actions.vue";
import MobileTable from "../../widgets/tables/MobileTable";
import DesktopTable from "../../widgets/tables/DesktopTable";
import { onBeforeMount, reactive } from "vue";
import store from "../../store";
import { openMode, actions } from "../../constants";

export default {
  components: { MobileTable, DesktopTable, Actions },

  setup() {
    const router = useRouter();
    const route = useRoute();
    const onCreate = () => {
      store.commit("setOpenMode", openMode.CREATE);
      router.push("/areascomunes/nuevo");
    };
    const onModify = () => {
      if (store.state.commonArea.selectedCommonAreas.length !== 1) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setOpenMode", openMode.MODIFY);
        router.push("/areascomunes/modificar");
      }
    };
    const onRemove = async () => {
      if (store.state.commonArea.selectedCommonAreas.length !== 1) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setLoading", true);
        const response = await store.dispatch(
          actions.commonAreaActions.delete,
          store.state.commonArea.selectedCommonAreas[0].id
        );
        if (response.ok) {
          store.commit("setSelectedCommonAreas", []);
          await store.dispatch(
            actions.commonAreaActions.findAll,
            store.state.general.selectedBuilding
          );
          store.commit("setLoading", false);
        } else {
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: response.message,
            life: 5000,
          });
          store.commit("setLoading", false);
        }
      }
    };

    const commonArea = reactive({
      columns: [
        {
          field: "name",
          header: "Nombre",
          sort: true,
        },
        {
          field: "reserve",
          header: "Reservable",
          sort: true,
        },
        {
          field: "cost",
          header: "Costo",
          sort: true,
          currency: true,
        },
        {
          field: "aforo",
          header: "Aforo",
        },
        {
          field: "location",
          header: "Ubicación",
        },
        {
          field: "description",
          header: "Descripción",
        },
      ],
      actions: [
        {
          name: "Nuevo",
          action: onCreate,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/areascomunes/nuevo"),
        },
        {
          name: "Modificar",
          action: onModify,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/areascomunes/modificar"),
        },
        {
          name: "Eliminar",
          action: onRemove,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/areascomunes/modificar"),
        },
      ],
    });

    onBeforeMount(async () => {
      store.commit("setLoading", true);
      store.commit("setSelectedCommonAreas", []);
      const finded = store.state.general.breadcrumbs.find(
        (item) => item.to === route.path
      );
      if (!finded)
        store.commit("addBreadcrumb", { label: route.name, to: route.path });
      await store.dispatch(
        actions.commonAreaActions.findAll,
        store.state.general.selectedBuilding
      );
      store.commit("setLoading", false);
    });

    return { store, commonArea };
  },
};
</script>

<style scoped></style>
